export default __webpack_public_path__ + "static/media/Mattia_e_Viola.d9195d77.jpg";